export default __webpack_public_path__ + "static/media/3.494f28bb.png";